<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <!-- === New Publicitygroup === -->
      <b-card>
        <div slot="header">
          <h1>Werbung - Neue Werbung erstellen</h1>
          <div class="card-header-actions"></div>
        </div>
        <b-card-body>
          <b-row>
            <b-col lg="8">
              <b-form
                v-on:submit.prevent="onSubmit"
                v-on:reset.prevent="onReset"
              >
                <!-- === Title of Advertisement === -->
                <b-form-group
                  id="advertisementInputGroup1"
                  label="Titel der Werbung *"
                  label-for="advertisementtitle"
                  description="(Der Titel Ihrer Werbung muss zwischen 3 und 64 Zeichen lang sein)"
                >
                  <b-form-input
                    :state="chkState('advertisementtitle')"
                    id="advertisementtitle"
                    type="text"
                    placeholder="Werbungstitel"
                    @click="$v.form.advertisementtitle.$reset()"
                    v-model.trim="form.advertisementtitle"
                  />
                  <b-form-invalid-feedback
                    :state="chkState('advertisementtitle')"
                  >
                    Pflichtfeld. Der Titel muss zwischen 3 und 64 Zeichen lang
                    sein.
                  </b-form-invalid-feedback>
                </b-form-group>

                <!-- === Mediafile of Advertisement === -->
                <b-form-group
                  id="advertisementInputGroup2"
                  label="Werbung *"
                  label-for="advertisementmedia"
                  description="(Datei muss ein Bild (jpg, png) oder Video (mp4) sein; empfohlene Auflösung für Bilder: 1920x1080, 3840x2160 Pixel)"
                >
                  <b-form-file
                    class="file-input"
                    :class="{
                      'error-border':
                        $v.form.advertisementmediafile.$dirty &&
                        $v.form.advertisementmediafile.$invalid,
                      'success-border':
                        $v.form.advertisementmediafile.$dirty &&
                        !$v.form.advertisementmediafile.$invalid,
                    }"
                    :state="chkState('advertisementmediafile')"
                    id="advertisementmedia"
                    ref="mediafileInput"
                    placeholder="Keine Datei ausgewählt"
                    :plain="true"
                    v-model="form.advertisementmediafile"
                  ></b-form-file>
                  <b-form-invalid-feedback
                    :state="chkState('advertisementmediafile')"
                  >
                    Pflichtfeld. Bitte wählen Sie eine gültige Datei aus.
                  </b-form-invalid-feedback>
                </b-form-group>

                <!-- === Displayimage of Advertisement === -->
                <b-form-group
                  id="advertisementInputGroup3"
                  label="Anzeigebild *"
                  label-for="advertisementdisplaymedia"
                  description="(Datei muss ein Bild sein, siehe unter Monitore/Administration/Vorlagen; maximale Dateigröße ist 2MB; empfohlene Auflösung: 1280x720, 1920x1080, 3840x2160 Pixel)"
                >
                  <b-form-file
                    id="advertisementdisplaymedia"
                    class="file-input"
                    :class="{
                      'error-border':
                        $v.form.advertisementdisplaymediafile.$dirty &&
                        $v.form.advertisementdisplaymediafile.$invalid,
                      'success-border':
                        $v.form.advertisementdisplaymediafile.$dirty &&
                        !$v.form.advertisementdisplaymediafile.$invalid,
                    }"
                    ref="displaymediafileInput"
                    placeholder="Keine Datei ausgewählt"
                    :plain="true"
                    v-model.trim="form.advertisementdisplaymediafile"
                  ></b-form-file>
                  <b-form-invalid-feedback
                    :state="chkState('advertisementdisplaymediafile')"
                  >
                    Pflichtfeld. Bitte wählen Sie eine gültige Datei aus.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form>
              <!-- === Buttons === -->
              <b-button
                v-if="showBtns"
                @click="submit"
                variant="primary"
                :disabled="licenseExpired"
              >
                Erstellen
              </b-button>
              <b-button
                v-if="showBtns"
                class="ml-1"
                @click="reset"
                variant="danger"
                >Verwerfen</b-button
              >
              <hr />
              <p class="req-field">* Pflichtfeld</p>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

import notificationmixin from "../../mixins/notificationmixin";

const formShape = {
  advertisementtitle: "",
  advertisementmediafile: "",
  advertisementdisplaymediafile: "",
};

// vuelidate - custom validators
const mediaFileValid = (value) => {
  const supportedMediaFileTypes = ["image/jpeg", "image/png", "video/mp4"];
  return supportedMediaFileTypes.includes(value.type);
};

const displayMediaFileValid = (value) => {
  const supportedMediaFileTypes = ["image/jpeg", "image/png"];
  return supportedMediaFileTypes.includes(value.type);
};

export default {
  data() {
    return {
      form: Object.assign({}, formShape),
      feedBack: "secondary",
      submitted: false,
      businessgroups: [],
      valid: true,
      showBtns: false,
    };
  },
  computed: {
    ...mapGetters(["licenseExpired"]),
    isValid() {
      return !this.$v.form.$invalid;
    },
    isDirty() {
      return this.$v.form.$anyDirty;
    },
  },
  methods: {
    ...mapActions(["submitAdvertisement"]),
    chkState(val) {
      const field = this.$v.form[val];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$error || field.$model === "");
    },
    reset() {
      this.$nextTick(() => {
        this.$v.$reset();
        this.submitted = false;
        this.form = Object.assign({}, formShape);
      });
    },
    async submit() {
      // force validations at this point
      this.$v.$touch();
      // if already submitted, prevent from re-submitting;
      // if one wants to submit another ad, first click 'dismiss'
      if (this.submitted === true) {
        this.notify(
          1,
          ``,
          `Der Beitrag wurde bereits abgeschickt.
          Bitte wählen Sie erst "Verwerfen" um einen weiteren Beitrag zu erstellen.`,
          this.$toast
        );
        return;
      }

      // only accept submission, once all fields are valid
      if (!this.$v.form.$invalid) {
        let err = await this.submitAdvertisement(this.form);
        this.notify(
          err,
          `Der Beitrag wurde erfolgreich angelegt!`,
          `Der Beitrag konnte nicht angelegt werden!`,
          this.$toast
        );
        // if submission is successful, set submitted flag
        if (!err) {
          this.submitted = true;
        }
      }
    },
  },
  mixins: [validationMixin, notificationmixin],
  validations: {
    form: {
      advertisementtitle: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(64),
      },
      advertisementmediafile: {
        required,
        mediaFileValid,
      },
      advertisementdisplaymediafile: {
        required,
        displayMediaFileValid,
      },
    },
  },
  components: {},
  mounted: function () {
    this.showBtns = true;
  },
};
</script>

<style>
.custom-file-input:lang(de) ~ .custom-file-label::after {
  content: 'Datei auswählen';
}

.file-input {
  padding: 5px 10px 5px 10px;
}

.req-field {
  font-size: 0.75em;
}

.error {
  color: red;
}

.error-border {
  border: 1px solid red;
  border-radius: 5px;
}

.success-border {
  border: 1px solid #4dbd74;
  border-radius: 5px;
}

.req-field {
  font-size: 0.75em;
}
</style>